import * as React from 'react';

import {useGetBucketedReportData} from 'shells/utils/hooks/use-get-bucketed-report-data';
import type {UnmappedReportData} from 'shells/utils/hooks/use-get-bucketed-report-data';

export type TrafficOverTimeData = {
    bucket: string;
    count: number;
    percent: number;
    segments: any[];
}[];

export const useGetTrafficOverTimeReport = (): {
    isLoading: boolean;
    isError: boolean;
    trafficOverTimeData: TrafficOverTimeData | null | undefined;
} => {
    const mapBucketsFunction = (data: UnmappedReportData) => {
        return {
            bucket: data.bucket,
            count: data.count.value,
            percent: data.count.percent || 0,
            segments: data.segments || [],
        };
    };

    // Memoize params
    const params = React.useMemo(
        () => ({
            type: 'trafficOverTime',
        }),
        []
    );

    const {reportData, isLoading, isError} = useGetBucketedReportData({
        reportUrl: 'competitordomains/report',
        params,
        mapBucketsFunction,
    });

    // @ts-expect-error
    return {trafficOverTimeData: reportData, isLoading, isError};
};
